import {
  methodAssignmentSchema,
  scopeMeasurementSchema,
  scopeTypeSchema,
} from 'features/libra/inspectionPlanning/techniqueTypes'
import { z } from 'zod'

const sourceMeasurementSchema = z.object({
  field: z.string(),
  label: z.string(),
  unit: z.string(),
})

export const executionColumnSchema = z.object({
  field: z.string(),
  label: z.string(),
  type: z.enum(['text', 'number', 'boolean', 'scope', 'thickness']),
  required: z.boolean().default(false),
  defaultValue: z.union([z.string(), z.number(), z.boolean()]).optional(),
  min: z.number().optional(),
  max: z.number().optional(),
  sourceMeasurements: z.array(sourceMeasurementSchema).default([]),
})
export type ExecutionColumn = z.infer<typeof executionColumnSchema>

export const executionSectionSchema = z.object({
  id: z.string(),
  type: z.literal('inspection_execution'),
  title: z.string(),
  field: z.string(),
  sourceZonesField: z.string(),
  areasField: z.string(),
  strategiesContextKey: z.string(),
  techniqueCatalogueContextKey: z.string(),
  allowRepeatedMethods: z.boolean(),
  columns: z.array(executionColumnSchema),
})
export type ExecutionSection = z.infer<typeof executionSectionSchema>

export const executionValueSchema = z
  .union([z.string(), z.number(), z.boolean(), scopeMeasurementSchema])
  .optional()
export type ExecutionValue = z.infer<typeof executionValueSchema>

export const executionRowSchema = z.object({
  id: z.string(),
  sourceZoneId: z.string(),
  inspectionAreaId: z.string(),
  methodAssignmentId: z.string(),
  // Preserve the method as recorded, even when its plan or catalogue changes.
  basis: z.object({
    zoneTitle: z.string(),
    areaTitle: z.string(),
    requiredCoveragePercent: z.number().optional(),
    method: methodAssignmentSchema.extend({
      method: z.string(),
      scopeType: scopeTypeSchema.optional(),
    }),
  }),
  values: z.record(z.string(), executionValueSchema),
})
export type ExecutionRow = z.infer<typeof executionRowSchema>
export const executionRowsSchema = z.array(executionRowSchema)
